module.exports = __webpack_public_path__ + "img/mic10.326d0546.jpg";